import { render, staticRenderFns } from "./ZupanijaForma.vue?vue&type=template&id=555a6206&scoped=true&"
import script from "./ZupanijaForma.vue?vue&type=script&lang=js&"
export * from "./ZupanijaForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555a6206",
  null
  
)

export default component.exports